module.exports = __webpack_public_path__ + "static/img/img(19).b7ff4cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/questionBank/img(19).png
// module id = y+Rr
// module chunks = 1